import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './OrderList.module.css';
import myAxios from '../AxiosUrl';
import OrderViewModal from '../OrderViewModal/OrderViewModalRedesigned';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import PrintInvoiceModal from '../PrintModal/PrintInvoiceModal';
import PrintStickerModal from '../PrintModal/PrintStickerModal';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import AssignOrderModal from '../AssignModal/AssignOrderModal';
import ChangeOrderStatusModal from '../ChangeStatusModal/ChangeOrderStatusModal';
import SortDay from './SortDay/SortDay';
import DatePickerFilter from './DatePickerFilter/DatePickerFilter';
import OTPFilter from './OTPFilter/OTPFilter';
import HowManyOrderWillShow from './HowManyOrderWillShow/HowManyOrderWillShow';
import OrderFilterSortSearch from './OrderFilterSortSearch/OrderFilterSortSearch';
import SelectedItemSection from './selectedItemSection/selectedItemSection';
import OrderTable from './OrderTable/OrderTable';
import { downloadCSV } from '../Helper/downloadCSV';
import { deleteOrderHelper } from '../Helper/deleteOrder';
import { steadFastEntryHelper } from '../Helper/steadFastEntry';
import { getOrders } from '../Helper/getOrders';
import { CallDetail } from '../AICalling/CallHistory';
import { orderDeliveryAmount } from '../Helper/deliveryAmount';
import { teamCan } from '../Helper/teamAccess';

function Order({ team = false }) {
    // Date states
    const [DateFrom, setDateFrom] = useState(new Date());
    const [DateTo, setDateTo] = useState(new Date());
    DateFrom.setHours(0, 0, 0);
    DateTo.setHours(0, 0, 0);

    // Other states
    const [DateSearch, setDateSearch] = useState(false);
    const [RefreshSe, setRefreshSe] = useState(1);
    // Team members act for their seller (Admin_Id) and see the store's orders like the seller does
    const uid = team ? localStorage.getItem('Admin_Id') : localStorage.getItem('id');
    const navigate = useNavigate();
    const [Totalpage, setTotalPage] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setPageLimit] = useState(10);
    const [OrderCal, setOrderCal] = useState([]);
    const [pData, setPdata] = useState([]);
    const [modalData, setmodalData] = useState([]);
    const [open, setOpenModal] = useState(false);
    const [searchN, setSearchNum] = useState('');
    const [orderStatus, setOrderStatusRaw] = useState(undefined);
    // "AI couldn't reach" chip (2026-11-04): New orders whose AI calls all went unanswered
    const [aiUnreached, setAiUnreached] = useState(false);
    const setOrderStatus = (s) => {
        setAiUnreached(false);
        setOrderStatusRaw(s);
    };
    const showAiUnreached = () => {
        setOrderStatusRaw(1);
        setAiUnreached(true);
    };
    const [refresh, setRefresh] = useState(false);
    const [openPrint, setOpenPrint] = useState(false);
    const [openStickerModal, setOpenStickerModal] = useState(false);
    const [stickerModalData, setStickerModalData] = useState(null);
    const [printModalData, setPrintModalData] = useState();
    const [loading, setLoading] = useState(true);
    const [FilterDate, setFilterDate] = useState('Today');
    const [ReceiveReturn, setReceiveReturn] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [SteadFastLoading, setSteadFastLoading] = useState(false);
    const [AssignOpen, setAssignOpen] = useState(false);
    const [ChangeStatusOpen, setChangeStatusOpen] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [Dhaka, setDhaka] = useState();
    const [Outside, setOutside] = useState();

    // Handle pagination change
    const PageNumber = (e, p) => {
        setPage(p);
    };

    // Toggle a single order item
    const handleToggleItem = (itemId) => {
        setSelectedItems((prev) =>
            prev.includes(itemId)
                ? prev.filter((item) => item !== itemId)
                : [...prev, itemId]
        );
    };

    // Toggle all orders
    const handleToggleAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(OrderD);
        }
        setSelectAll(!selectAll);
    };

    // Filter orders based on status and return flag
    const OrderD = pData.filter((fdata) => {
        if (orderStatus === undefined) {
            return fdata;
        } else if (ReceiveReturn) {
            return fdata.CourierReturn === 'no' && fdata.orderStatus === 6;
        } else {
            return fdata.orderStatus === orderStatus;
        }
    });

    // ---- AI calling (2026-10-31): last call per order, AI confirm call, softphone, bulk AI call
    const [callInfo, setCallInfo] = useState({ enabled: false, status: {} });
    const [callOpen, setCallOpen] = useState(null);
    const closeCall = useCallback(() => setCallOpen(null), []);
    const idsKey = pData.map((o) => o._id).join(',');
    const loadCallStatus = useCallback(async () => {
        if (!idsKey) return;
        try {
            const res = await myAxios.get('call/order-status', { params: { ids: idsKey } });
            setCallInfo({ enabled: !!res.data?.enabled, status: res.data?.status || {} });
        } catch (e) {
            /* AI calling not available: no call column */
        }
    }, [idsKey]);
    useEffect(() => {
        loadCallStatus();
    }, [loadCallStatus]);
    // while a call is waiting / ringing, look again every 15 s
    useEffect(() => {
        if (!Object.values(callInfo.status).some((s) => s.waiting)) return undefined;
        const t = setTimeout(loadCallStatus, 15000);
        return () => clearTimeout(t);
    }, [callInfo, loadCallStatus]);
    const aiCallOrder = async (order) => {
        try {
            const res = await myAxios.post('call/order', { orderId: order._id });
            toast.success(res.data?.message || 'The AI will call this customer');
            loadCallStatus();
        } catch (e) {
            toast.error(e?.response?.data?.message || 'Could not queue the call');
        }
    };
    const softphoneCall = (order) => {
        window.dispatchEvent(new CustomEvent('etech-softphone-dial', { detail: { mobile: order.cMobile, orderId: order._id } }));
    };
    const aiCallSelected = async () => {
        try {
            const res = await myAxios.post('call/orders/bulk', { orderIds: selectedItems.map((o) => o._id) });
            toast.success(res.data?.message || 'Queued');
            if (res.data?.skipped?.length) toast.info(`Skipped: ${[...new Set(res.data.skipped.map((s) => s.reason))].join(' · ')}`);
            setSelectedItems([]);
            setSelectAll(false);
            loadCallStatus();
        } catch (e) {
            toast.error(e?.response?.data?.message || 'Could not queue the calls');
        }
    };

    // Get orders using helper
    const getData = () => {
        setLoading(true);
        getOrders({
            searchN: searchN || undefined,
            orderStatus: orderStatus !== undefined ? orderStatus : null,
            aiStatus: aiUnreached ? 'unreached' : undefined,
            uid,
            page,
            limit,
            FilterDate,
            DateFrom,
            DateTo,
            DateSearch,
        })
            .then((res) => {
                // Safety check: ensure data is always an array
                const orderData = res.data?.data || [];
                const totalPages = res.data?.total || 0;

                setPdata(Array.isArray(orderData) ? orderData : []);
                setTotalPage(totalPages);
                setLoading(false);

                // Log for debugging
                if (!res.data?.success) {
                    console.warn('API returned error:', res.data?.error);
                }
            })
            .catch((error) => {
                console.error('Error fetching orders:', error);
                setPdata([]); // Set empty array on error
                setTotalPage(0);
                setLoading(false);
            });
    };

    // Calculation of order metrics (advance, discount, etc.)
    useEffect(() => {
        // Filter orders based on status and return flag
        const filteredOrderD = pData.filter((fdata) => {
            if (orderStatus === undefined) {
                return true;
            } else if (ReceiveReturn) {
                return fdata.CourierReturn === 'no' && fdata.orderStatus === 6;
            } else {
                return fdata.orderStatus === orderStatus;
            }
        });

        let Today_Adv = 0;
        filteredOrderD.forEach((data) => {
            if (data.advance) {
                Today_Adv += Number(data.advance);
            }
        });

        // Calculate total amount from all orders in filteredOrderD
        let TakaTotalDay = 0;
        let TodaySale = 0;
        filteredOrderD.forEach((data) => {
            // Calculate total with delivery charge, advance, and discount
            let totalAmount = Number(data.totalPrice);

            // Add delivery charge
            totalAmount += orderDeliveryAmount(data, Dhaka, Outside);

            // Subtract advance and discount
            if (data.advance) {
                totalAmount -= Number(data.advance);
            }
            if (data.discount) {
                totalAmount -= Number(data.discount);
            }

            TakaTotalDay += totalAmount;

            if (data.orderData) {
                data.orderData.forEach((totalquantity) => {
                    TodaySale += Number(totalquantity.quantity);
                });
            }
        });

        const todayProfit = pData.filter((order) =>
            [2, 3, 4, 11].includes(order.orderStatus)
        );
        let ProfitToday = 0;
        let DiscountToday = 0;
        todayProfit.forEach((data) => {
            if (data.discount) DiscountToday += Number(data.discount);
            if (data.profit) ProfitToday += Number(data.profit);
        });

        const todayReturn = pData.filter((order) =>
            [6].includes(order.orderStatus)
        );
        let returnAmunt = 0;
        let returnProfit = 0;
        todayReturn.forEach((data) => {
            if (data.deliveryCharge === 'dhaka') {
                const amount = 55;
                if (data.ReturnAmount) {
                    if (Number(data.ReturnAmount) > amount) {
                        returnProfit = Number(data.ReturnAmount) - amount;
                    } else {
                        returnAmunt += amount - Number(data.ReturnAmount);
                    }
                } else {
                    returnAmunt += amount;
                }
            }
            if (data.deliveryCharge === 'outside') {
                const amount = 95;
                if (data.ReturnAmount) {
                    if (Number(data.ReturnAmount) > amount) {
                        returnProfit = Number(data.ReturnAmount) - amount;
                    } else {
                        returnAmunt += amount - Number(data.ReturnAmount);
                    }
                } else {
                    returnAmunt += amount;
                }
            }
        });

        const OrderDataCal = {
            advance: Today_Adv,
            discount: DiscountToday,
            sale: TodaySale,
            taka: TakaTotalDay,
            Profit: ProfitToday - returnAmunt + returnProfit,
            Return: todayReturn.length,
        };

        setOrderCal(OrderDataCal);
    }, [RefreshSe, refresh, pData, orderStatus, ReceiveReturn, Dhaka, Outside, aiUnreached]);

    // Delete alert using helper
    const AlartSubmit = (id) => {
        setRefresh(false);
        confirmAlert({
            title: 'DELETE CONFIRMATION',
            message: 'Are you sure to delete the product.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        deleteOrderHelper(id, setRefresh);
                        setPdata((prevData) =>
                            prevData.filter((order) => order._id !== id)
                        );
                    },
                },
                {
                    label: 'No',
                    onClick: () => null,
                },
            ],
        });
    };

    // Trigger SteadFastEntry using helper
    const SteadFastEntry = () => {
        steadFastEntryHelper(
            uid,
            selectedItems,
            setSteadFastLoading,
            setSelectedItems,
            () => setRefreshSe((n) => n + 1)
        );
    };

    // Handle Print Invoice for selected items
    const handlePrintInvoice = () => {
        if (selectedItems.length === 0) {
            alert('Please select at least one order');
            return;
        }

        // For single or multiple orders, open modal with first order
        // The modal has both "Print Invoice" and "Print Sticker" buttons
        setPrintModalData(selectedItems[0]);
        setOpenPrint(true);

        // If multiple orders, inform user
        if (selectedItems.length > 1) {
            toast.info(`Printing ${selectedItems.length} orders. Click Print Invoice for each.`);
        }
    };

    // Handle Print Sticker for selected items
    const handlePrintSticker = () => {
        if (selectedItems.length === 0) {
            alert('Please select at least one order');
            return;
        }

        const firstOrder = selectedItems[0];

        // Calculate total price with delivery
        let PriceAfterAdvance;
        if (firstOrder?.advance && firstOrder?.discount) {
            let ad = parseInt(firstOrder.advance) + parseInt(firstOrder.discount);
            PriceAfterAdvance = firstOrder.totalPrice - ad;
        } else if (firstOrder?.advance) {
            PriceAfterAdvance = firstOrder.totalPrice - parseInt(firstOrder.advance);
        } else if (firstOrder?.discount) {
            PriceAfterAdvance = firstOrder.totalPrice - parseInt(firstOrder.discount);
        } else {
            PriceAfterAdvance = firstOrder?.totalPrice || 0;
        }

        const deliveryCharge = orderDeliveryAmount(firstOrder, Dhaka, Outside, Dhaka);
        const totalWithDelivery = parseInt(deliveryCharge || 0) + parseInt(PriceAfterAdvance);

        // Set sticker data and open modal
        setStickerModalData({
            InvoiceId: firstOrder?.InvoiceId,
            StoreName: firstOrder?.StoreName || 'Store',
            Name: firstOrder?.cName,
            Mobile: firstOrder?.cMobile,
            Address: firstOrder?.address,
            TotalPrice: totalWithDelivery,
            PaymentType: firstOrder?.PaymentType || 'cod',
            Products: firstOrder?.orderData,
        });
        setOpenStickerModal(true);

        if (selectedItems.length > 1) {
            toast.info(`Printing label for ${selectedItems.length} orders. Print each separately.`);
        }
    };

    // Handle bulk delete for selected items
    const handleBulkDelete = () => {
        if (selectedItems.length === 0) {
            alert('Please select at least one order');
            return;
        }

        confirmAlert({
            title: 'DELETE CONFIRMATION',
            message: `Are you sure you want to delete ${selectedItems.length} order(s)?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        selectedItems.forEach(order => {
                            deleteOrderHelper(order._id, setRefresh);
                        });
                        setPdata((prevData) =>
                            prevData.filter((order) => !selectedItems.some(selected => selected._id === order._id))
                        );
                        setSelectedItems([]);
                        setSelectAll(false);
                    },
                },
                {
                    label: 'No',
                    onClick: () => null,
                },
            ],
        });
    };

    // Get orders on dependency changes
    useEffect(() => {
        getData();
    }, [refresh, page, limit, FilterDate, RefreshSe, aiUnreached]); // eslint-disable-line react-hooks/exhaustive-deps

    // Get domain data
    useEffect(() => {
        myAxios
            .get(`get-domain-new/${uid}`)
            .then((res) => {
                if (res.data) {
                    setDhaka(parseInt(res.data.Dhaka || 0));
                    setOutside(parseInt(res.data.Outside || 0));
                }
            })
            .catch((err) => console.error('Error fetching domain:', err));
    }, [uid]);

    return (
        <div className={styles['shopify-container']}>
            <ToastContainer />
            {AssignOpen && (
                <AssignOrderModal
                    setAssignOpen={setAssignOpen}
                    data={selectedItems}
                    setRefresh={setRefresh}
                    setSelectedItems={setSelectedItems}
                />
            )}
            {ChangeStatusOpen && (
                <ChangeOrderStatusModal
                    setChangeStatusOpen={setChangeStatusOpen}
                    data={selectedItems}
                    setRefresh={setRefresh}
                    setSelectedItems={setSelectedItems}
                />
            )}
            {open && (
                <OrderViewModal
                    modalData={modalData}
                    setOpenModal={setOpenModal}
                    setRefresh={setRefresh}
                    handleUpdate={getData}
                />
            )}
            {openPrint && (
                <PrintInvoiceModal
                    printModalData={printModalData}
                    setOpenPrint={setOpenPrint}
                    setRefresh={setRefresh}
                    setOpenStickerModal={setOpenStickerModal}
                    setStickerModalData={setStickerModalData}
                />
            )}
            {openStickerModal && (
                <PrintStickerModal
                    setOpenStickerModal={setOpenStickerModal}
                    stickerData={stickerModalData}
                />
            )}

            {/* Shopify-style Filters Section */}
            <div className={styles['filters-section']}>
                <div className={styles['filters-row']}>
                    <SortDay setFilterDate={setFilterDate} />
                    <DatePickerFilter
                        DateFrom={DateFrom}
                        setDateFrom={setDateFrom}
                        DateTo={DateTo}
                        setDateTo={setDateTo}
                        setDateSearch={setDateSearch}
                        setRefreshSe={setRefreshSe}
                    />
                    <HowManyOrderWillShow setPageLimit={setPageLimit} />
                </div>

                <OrderFilterSortSearch
                    setOrderStatus={setOrderStatus}
                    setReceiveReturn={setReceiveReturn}
                    setLoading={setLoading}
                    setSearchNum={setSearchNum}
                    searchN={searchN}
                    orderStatus={orderStatus}
                    aiUnreached={aiUnreached}
                    showAiUnreached={showAiUnreached}
                    ReceiveReturn={ReceiveReturn}
                    triggerSearch={getData}
                    setRefreshSe={setRefreshSe}
                />
            </div>

            {/* Selected Items Actions */}
            <SelectedItemSection
                selectedItems={selectedItems}
                setChangeStatusOpen={teamCan('orders.status') ? setChangeStatusOpen : null}
                setAssignOpen={setAssignOpen}
                SteadFastEntry={teamCan('orders.courier') ? SteadFastEntry : null}
                SteadFastLoading={SteadFastLoading}
                DownloadCSV={() =>
                    downloadCSV(selectedItems, Dhaka, Outside, setSelectedItems)
                }
                handlePrintInvoice={handlePrintInvoice}
                handlePrintSticker={handlePrintSticker}
                handleBulkDelete={teamCan('orders.delete') ? handleBulkDelete : null}
                hideAssign={team}
                onAiCall={callInfo.enabled && teamCan('orders.call') ? aiCallSelected : null}
            />

            {/* Shopify-style Stats Cards */}
            <OTPFilter OrderD={OrderD} OrderCal={OrderCal} loading={loading} />

            {/* Shopify-style Table */}
            <div className={styles['table-section']}>
                <OrderTable
                    OrderD={OrderD}
                    setmodalData={setmodalData}
                    setOpenModal={setOpenModal}
                    setRefresh={setRefresh}
                    setPrintModalData={setPrintModalData}
                    setOpenPrint={setOpenPrint}
                    selectedItems={selectedItems}
                    handleToggleItem={handleToggleItem}
                    handleToggleAll={handleToggleAll}
                    selectAll={selectAll}
                    navigate={navigate}
                    AlartSubmit={teamCan('orders.delete') ? AlartSubmit : null}
                    loading={loading}
                    editPath={!teamCan('orders.edit') ? null : team ? '/edit-team-order' : '/edit-order'}
                    callInfo={callInfo}
                    onAiCall={aiCallOrder}
                    onSoftphoneCall={softphoneCall}
                    onOpenCall={setCallOpen}
                />
            </div>
            {callOpen && <CallDetail id={callOpen} onClose={closeCall} />}

            {/* Shopify-style Pagination */}
            {!loading && Totalpage > 0 && (
                <div className={styles['pagination-section']}>
                    <Stack spacing={2}>
                        <Pagination
                            count={Totalpage}
                            color="primary"
                            onChange={PageNumber}
                        />
                    </Stack>
                </div>
            )}

        </div>
    );
}

export default Order;
